<div class="grid-x grid-margin-x margin">
  <div class="cell small-12 xmedium-7 small-order-2 xmedium-order-1">
    @if(anfrage?.measureResult?.demand) {
      <table class="wirtschaftlichkeit" [class.loading-overlay]="loading">
        <thead>
        <tr>
          <th>&nbsp;</th>
          <th [innerHTML]="textkeyPrefix + 'bestand' | translate"></th>
          <th [innerHTML]="(textkeyPrefix + 'modernisierung.' + financing) | translate"></th>
        </tr>
        </thead>
        <tbody>
          @for(key of ['investitionskosten_monat', 'energiekosten_monat', 'co2_kosten_monat']; track key) {
            <tr>
              <th>
                <span [innerHTML]="(textkeyPrefix + '' + key) | translate"></span>
                <app-sanierung-help-button [toggles]="toggle" [toggleName]="key"></app-sanierung-help-button>
              </th>
              <td>{{ measureResult.demand.wirtschaftlichkeit[key] | number: '1.0-0' }} €</td>
              <td>{{ measureResult.costs?.financing[financing]?.wirtschaftlichkeit[key] | number: '1.0-0' }} €</td>
            </tr>
            @if (toggle[key]) {
              <tr>
                <td colspan="3">
                  @if (key === 'energiekosten_monat') {
                    <app-sanierung-help-callout
                        [toggles]="toggle"
                        [toggleName]="key"
                        [textkey]="textkeyPrefix + 'hint.' + textkeyPostfixHint + key"
                      ></app-sanierung-help-callout>
                  }
                  @else if (key === 'co2_kosten_monat' && (anfrage?.verbrauchsanalyseInput?.energietraeger_name === 'fernwaerme' || anfrage?.massnahmen?.heating === 'fernwaerme')) {
                    <app-sanierung-help-callout
                      [toggles]="toggle"
                      [toggleName]="key"
                      [textkey]="textkeyPrefix + 'hint.fernwaerme.' + key"
                    ></app-sanierung-help-callout>
                  }
                  @else {
                    <app-sanierung-help-callout
                      [toggles]="toggle"
                      [toggleName]="key"
                      [textkey]="textkeyPrefix + 'hint.' + key"
                    ></app-sanierung-help-callout>
                  }
                </td>
              </tr>
            }
          }
          @for(key of ['gesamtkosten_monat', 'gesamtkosten_jahr', 'gesamtkosten_langfristig']; track key) {
            <tr class="footer">
              <th [innerHTML]="(textkeyPrefix + '' + key) | translate"></th>
                <td>{{ (measureResult.demand.wirtschaftlichkeit[key]) | number: '1.0-0' }} €</td>
                <td>{{ (measureResult.costs.financing[financing].wirtschaftlichkeit[key]) | number: '1.0-0' }} €</td>
            </tr>
          }
        </tbody>
      </table>
      <div class="callout">
        @if (measureResult.costs.financing[financing].wirtschaftlichkeit['gesamtkosten_langfristig'] < measureResult.demand.wirtschaftlichkeit['gesamtkosten_langfristig']) {
          <p [innerHTML]="textkeyPrefix + 'callout.positive' | translate"></p>
        }
        @else {
          <p [innerHTML]="textkeyPrefix + 'callout.negative' | translate:{totalMonthly: (((measureResult.costs.financing[financing].wirtschaftlichkeit.gesamtkosten_jahr - measureResult.demand.wirtschaftlichkeit.gesamtkosten_jahr) / 12) | number:'1.0-0') }"></p>
        }
      </div>
    }
  </div>
  <div class="cell small-12 xmedium-5 small-order-1 xmedium-order-2">
    <app-side-helptext [textkey]="textkeyPrefix + 'hint'" viewPoint="xmedium"></app-side-helptext>
  </div>
</div>
